import { render, staticRenderFns } from "./price-overrides.vue?vue&type=template&id=5dedddc0"
import script from "./price-overrides.vue?vue&type=script&lang=js"
export * from "./price-overrides.vue?vue&type=script&lang=js"
import style0 from "./price-overrides.vue?vue&type=style&index=0&id=5dedddc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports